import { gql } from '@apollo/client';

const BillingProfileDetailsforFetchBillingProfilesForCustomer = gql`
  fragment BillingProfileDetailsforFetchBillingProfilesForCustomer on InvoiceGroupConnection {
    nodes {
      id
      name
      isActive
      currency
      shipToParty {
        id
        name
      }
      shipToPriceEligibility
      defaultPaymentMethod(refetchDefaultPaymentMethod: $refetchDefaultPaymentMethod) {
        type
      }
    }
  }
`;

export const fetchBillingProfilesForCustomer = gql`
  ${BillingProfileDetailsforFetchBillingProfilesForCustomer}
  query fetchBillingProfilesForCustomer(
    $id: ID!
    $filterOptions: [FilterOption]!
    $searchOptions: ConnectionSearchOptions
    $refetchDefaultPaymentMethod: Boolean = false
    $isFetchBillingProfilesViaCCPEnabled: Boolean = false
  ) {
    transactionAccount(id: $id) {
      billingProfiles(filterOptions: $filterOptions, searchOptions: $searchOptions)
        @skip(if: $isFetchBillingProfilesViaCCPEnabled) {
        ...BillingProfileDetailsforFetchBillingProfilesForCustomer
      }
      billingProfilesFromCCP(filterOptions: $filterOptions, searchOptions: $searchOptions)
        @include(if: $isFetchBillingProfilesViaCCPEnabled) {
        ...BillingProfileDetailsforFetchBillingProfilesForCustomer
      }
    }
  }
`;
